'use strict';

// TODO: Review this when all payment go through Stripe.

/**
 * Nature's Menu Braintree bootstrap: same as int_braintree/braintreeSFRA, but ./braintreeAccount is the NM override.
 * Other modules resolve via webpack alias "braintree" -> int_braintree client/js.
 */
module.exports = function () {
    // Used only for Paypal. In future "client token" generation approach will be refactored
    var paymentMethodGeneral = require('braintree/braintree/paymentMethodGeneral');

    // General global variables
    var clientTokenPromise = paymentMethodGeneral.createGeneralClientInstancePromise();
    var isCheckoutPage = Boolean(document.querySelector('#checkout-main'));

    if (isCheckoutPage && $('#checkout-main').attr('data-zero-order') == 'true' && $('#checkout-main').attr('data-allow-zero-order') != 'true') {
        return;
    }

    /* ------------------------General Account functionality------------------------ */
    var btAccountBusinessLogic = require('./braintreeAccount');
    // Common Credit Card and SRC Account functionality
    btAccountBusinessLogic.initAccount();

    /* ------------------------General Checkout functionality----------------------- */
    if (isCheckoutPage) {
        paymentMethodGeneral.fillPaymentSammaryContainer();
        paymentMethodGeneral.initPaymentMethodTabClickBehavior();
    }

    /* ------------------------Credit Card------------------------ */
    var creditCardBusinessLogic = require('braintree/braintree/creditcard/creditCard');

    var creditCardOnAccountEnabled = Boolean(document.querySelector('.js_braintree_addCreditCardForm'));
    var creditCardEnabledOnCheckout = Boolean(document.querySelector('.js_braintree_creditCardContent'));

    creditCardBusinessLogic.init();

    if (creditCardOnAccountEnabled) {
        creditCardBusinessLogic.initAccount();
    }

    if (creditCardEnabledOnCheckout) {
        creditCardBusinessLogic.initCheckout();
    }

    /* --------------------------PayPal-------------------------- */
    var payPalBusinessLogic = require('braintree/braintree/paypal/payPal');

    var payPalEnabledOnCheckout = Boolean(document.querySelector('.js_braintree_paypalContent'));
    var payPalEnabledOnProduct = Boolean(document.querySelector('.prices-add-to-cart-actions .js_braintree_paypal_cart_button'));
    var payPalEnabledOnCart = Boolean(document.querySelector('.cart-page .js_braintree_paypal_cart_button'));
    var payPalEnabledOnAccountPage = Boolean(document.querySelector('.paypal-accounts'));

    payPalBusinessLogic.init(clientTokenPromise);


    if (payPalEnabledOnCheckout) {
        payPalBusinessLogic.initCheckout();
    }

    if (payPalEnabledOnProduct) {
        payPalBusinessLogic.initProduct();
    }

    // Validation on enabled/disabled PayPal button for MiniCart located isinside MiniCart component
    payPalBusinessLogic.initMiniCart();

    if (payPalEnabledOnCart) {
        payPalBusinessLogic.initCart();
    }

    if (payPalEnabledOnAccountPage) {
        payPalBusinessLogic.initAccount();
    }

    /* --------------------------GooglePay------------------------- */
    var googlePayBusinnessLogic = require('braintree/braintree/googlepay/googlePay');

    var googlePayEnabledOnCheckout = Boolean(document.querySelector('.js_braintree_googlepayContent'));
    var googlePayEnabledOnCart = Boolean(document.querySelector('.braintree-cart-google-button'));

    googlePayBusinnessLogic.init();

    if (googlePayEnabledOnCheckout) {
        googlePayBusinnessLogic.initCheckout();
    }

    if (googlePayEnabledOnCart) {
        googlePayBusinnessLogic.initCart();
    }

    /* --------------------------ApplePay------------------------- */
    var applePayBusinessLogic = require('braintree/braintree/applepay/applePay');

    var applePayEnabledOnCheckout = Boolean(document.querySelector('.js_braintree_applepayContent'));
    var applePayEnabledOnCart = Boolean(document.querySelector('.braintree-cart-apple-button'));

    applePayBusinessLogic.init();

    if (applePayEnabledOnCart) {
        applePayBusinessLogic.initCart();
    }

    if (applePayEnabledOnCheckout) {
        applePayBusinessLogic.initCheckout();
    }

    /* --------------------------Venmo---------------------------- */
    var venmoBusinessLogic = require('braintree/braintree/venmo/venmo');

    var isVenmoEnabledOnAccountPage = Boolean(document.querySelector('.venmo-accounts'));
    var isVenmoEnabledOnBillingPage = Boolean(document.querySelector('.js_braintree_venmoContent'));

    venmoBusinessLogic.init();

    if (isVenmoEnabledOnAccountPage) {
        venmoBusinessLogic.initAccount();
    }

    if (isVenmoEnabledOnBillingPage) {
        venmoBusinessLogic.initBillingCheckout();
    }

    /* --------------------------SRC------------------------------ */
    var srcBusinessLogic = require('braintree/braintree/src/src');

    var isSrcEnabledOnAccountPage = Boolean(document.querySelector('.js_braintree_addSrcAccountForm'));
    var isSrcEnabledOnCartPage = Boolean(document.querySelector('.braintree-cart-src-button'));
    var isSrcEnabledOnBillingPage = Boolean(document.querySelector('.js_braintree_srcContent'));

    srcBusinessLogic.init();

    if (isSrcEnabledOnAccountPage) {
        srcBusinessLogic.initAccount();
    }

    if (isSrcEnabledOnCartPage) {
        srcBusinessLogic.initCartCheckout();
    }

    if (isSrcEnabledOnBillingPage) {
        srcBusinessLogic.initBillingCheckout();
    }

    /* --------------------------LPM-------------------------- */
    var lpmBusinessLogic = require('braintree/braintree/local/lpm');
    var isLpmEnebledOnBillingPage = Boolean(document.querySelector('.js_braintree-lpmContent'));

    if (isLpmEnebledOnBillingPage) {
        lpmBusinessLogic.init();
    }
};
